/**
 * Runtime environment configuration
 *
 * Same window._env_-over-import.meta.env pattern as the Admin UI's
 * config/env.ts: build-time Vite vars for local dev, runtime values
 * injected by docker-entrypoint.sh for Docker deployments.
 */

declare global {
  interface Window {
    _env_?: {
      VITE_GATEWAY_URL?: string;
      VITE_OKTA_ISSUER?: string;
      VITE_OKTA_CLIENT_ID?: string;
      VITE_APP_NAME?: string;
    };
  }
}

function getEnv(key: string, defaultValue: string = ''): string {
  if (typeof window !== 'undefined' && window._env_) {
    const value = window._env_[key as keyof typeof window._env_];
    if (value) {
      return value;
    }
  }

  const buildTimeValue = import.meta.env[key];
  return buildTimeValue || defaultValue;
}

export const config = {
  gatewayUrl: getEnv('VITE_GATEWAY_URL', 'http://localhost:8000'),
  oktaIssuer: getEnv('VITE_OKTA_ISSUER', ''),
  oktaClientId: getEnv('VITE_OKTA_CLIENT_ID', ''),
  appName: getEnv('VITE_APP_NAME', 'My MCP Bridge Access'),
};

if (!config.oktaIssuer || !config.oktaClientId) {
  console.warn(
    'Self-service UI configuration incomplete. Okta authentication will not work.',
    {
      oktaIssuer: config.oktaIssuer ? '✓ set' : '✗ missing',
      oktaClientId: config.oktaClientId ? '✓ set' : '✗ missing'
    }
  );
}
